import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GoogleCalendarServiceAccountRoutingModule } from './google-calendar-service-account-routing.module';
import { GoogleCalendarServiceAccountComponent } from './google-calendar-service-account.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddEditGoogleCalendarServiceAccountComponent } from './add-edit-google-calendar-service-account/add-edit-google-calendar-service-account.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { GoogleCalenderExcelImportComponent } from './google-calender-excel-import/google-calender-excel-import.component';
import { CustomExcelMapperModule } from 'src/app/shared/custom-excel-mapper/custom-excel-mapper.module';
import { OutlookCalenderModule } from 'src/app/shared/outlook-calender/outlook-calender.module';
import { ModuleNameModule } from 'src/app/shared/module-name-pipe/modulename.module';
import { TrialExipedMessageModule } from 'src/app/shared/trial-exiped-message/trial-exiped-message.module';
import { ColumnVisibilityModule } from 'src/app/shared/column-visibility/column-visibility.module';


@NgModule({
  declarations: [
    GoogleCalendarServiceAccountComponent,
    AddEditGoogleCalendarServiceAccountComponent,
    GoogleCalenderExcelImportComponent
  ],
  imports: [
    CommonModule,
    GoogleCalendarServiceAccountRoutingModule,
    SharedModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    MatDatepickerModule,
    CustomExcelMapperModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    OutlookCalenderModule,
    ModuleNameModule,
    TrialExipedMessageModule,
    ColumnVisibilityModule
  ],
  exports: [

    GoogleCalendarServiceAccountComponent
  ]
})
export class GoogleCalendarServiceAccountModule { }
